const conversionRates = {
  R() {
    if (localStorage.getItem('legendbeds.conversion_rates')) {
      return JSON.parse(localStorage.getItem('legendbeds.conversion_rates'));
    } else {
      // TODO: how do I call the action to refresh this?
    }
  }
}

export default conversionRates;
